<script>
import ServerMonitor from "@/views/Panel/PanelView/ServerMonitor.vue";

export default {
    name: "ServersBlock",
    components: { ServerMonitor },
};
</script>

<template>
    <div class="block">
        <h2 class="text-center display-3 mb-4">Сервера</h2>
        <div class="row justify-content-center">
            <div class="col-12 col-md-6">
                <server-monitor
                    class="p-3 rounded-4"
                    name="Minecolonies"
                    description="Добро пожаловать на Minecolonies."
                    ip="s3.streamer.fun"
                    port="25110"
                    :background="require('@/assets/servers/medieval.jpg')"
                />
            </div>
        </div>
    </div>
</template>

<style scoped></style>
